/**
 *  Note the assigned values 1 / -1 are important as multiplier in table sort.
 */
export enum SortDirection {
	ASC = 1,
	DESC = -1,
	UNSORTED = 0
}
